import { StaticModal } from '@nexelem/modals';
import { useCustomTranslation } from '../../../../hooks';
import { useTableInfiniteQuery } from '@nexelem/tanstack-table';
import { BillOfMaterialDataSourceResult } from './createBillOfMaterialDataSource';

export const BillOfMaterialHeader = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.billOfMaterial');
  const { dataPages } = useTableInfiniteQuery<BillOfMaterialDataSourceResult>();
  const data = dataPages[0]?.result;

  return (
    <StaticModal.Header withCloseButton className="mb-6 border-b border-border-primary">
      {tWrapper('billOfMaterialModalHeader', {
        productionLotNumber: data?.taskName,
      })}
      <span className="ml-2 text-s24">({tWrapper('productName', { productName: data?.productDetails.name })})</span>
    </StaticModal.Header>
  );
};
